module.exports = __webpack_public_path__ + "static/media/moviemizer.37d56e50.png";